import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
    CalendarDays,
    ArrowRight,
    BookOpen,
} from "lucide-react";
import api from "../api/api";

export default function HomeBlogs() {

    const [blogs, setBlogs] = useState([]);

    useEffect(() => {

        api.get("/blogs")
            .then((res) => {
                setBlogs(res.data.slice(0, 3));
            });

    }, []);

    if (!blogs.length) return null;

    return (

        <section className="py-24 bg-white dark:bg-gray-950">

            <div className="container mx-auto px-6">

                {/* Header */}

                <div className="text-center mb-14">

                    <span
                        className="
                            inline-flex
                            items-center
                            gap-2
                            rounded-full
                            bg-[#D9BB74]/20
                            px-5
                            py-2
                            text-sm
                            font-semibold
                            text-[#0F766E]
                        "
                    >
                        <BookOpen size={16} />
                        Travel Blog
                    </span>

                    <h2 className="mt-5 text-4xl font-bold text-gray-900 dark:text-white">
                        Latest Travel Stories
                    </h2>

                    <p className="mt-4 max-w-2xl mx-auto text-gray-600 dark:text-gray-400">
                        Explore hotel guides, destination tips, travel inspiration,
                        and exclusive UAE experiences.
                    </p>

                </div>


                {/* Cards */}

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">

                    {blogs.map((blog) => {

                        return (

                            <Link
                                key={blog.id}
                                to={`/blogs/${blog.slug}`}
                                className="
                                    group
                                    overflow-hidden
                                    rounded-3xl
                                    border
                                    border-gray-100
                                    dark:border-gray-800
                                    bg-white
                                    dark:bg-[#111827]
                                    shadow-lg
                                    hover:-translate-y-2
                                    hover:shadow-2xl
                                    transition-all
                                    duration-500
                                "
                            >

                                {/* Image */}

                                <div className="relative overflow-hidden">

                                    <img
                                        src={blog.thumbnail_image}
                                        alt={blog.title}
                                        className="
                                            h-64
                                            w-full
                                            object-cover
                                            transition
                                            duration-700
                                            group-hover:scale-110
                                        "
                                    />

                                    <div
                                        className="
                                            absolute
                                            top-5
                                            left-5
                                            rounded-full
                                            bg-[#D9BB74]
                                            px-4
                                            py-1.5
                                            text-xs
                                            font-semibold
                                            text-[#1B1B1B]
                                        "
                                    >
                                        Travel Guide
                                    </div>

                                </div>


                                <div className="p-7">

                                    <div
                                        className="
                                            flex
                                            items-center
                                            gap-2
                                            text-sm
                                            text-gray-500
                                            mb-4
                                        "
                                    >

                                        <CalendarDays size={15} />

                                        {new Date(blog.created_at).toLocaleDateString()}

                                    </div>


                                    <h3
                                        className="
                                            text-2xl
                                            font-bold
                                            text-gray-900
                                            dark:text-white
                                            mb-4
                                            transition
                                            group-hover:text-[#0F766E]
                                            line-clamp-2
                                        "
                                    >
                                        {blog.title}
                                    </h3>

                                    <p
                                        className="
                                            text-gray-600
                                            dark:text-gray-400
                                            leading-7
                                            line-clamp-3
                                        "
                                    >
                                        {blog.excerpt}
                                    </p>

                                    <div
                                        className="
                                            mt-7
                                            flex
                                            items-center
                                            justify-between
                                        "
                                    >

                                        <span
                                            className="
                                                text-sm
                                                font-semibold
                                                text-[#0F766E]
                                            "
                                        >
                                            Read Article
                                        </span>

                                        <div
                                            className="
                                                w-10
                                                h-10
                                                rounded-full
                                                bg-[#D9BB74]
                                                flex
                                                items-center
                                                justify-center
                                                transition-all
                                                duration-300
                                                group-hover:bg-[#0F766E]
                                            "
                                        >

                                            <ArrowRight
                                                size={18}
                                                className="
                                                    text-[#1B1B1B]
                                                    transition-all
                                                    duration-300
                                                    group-hover:text-white
                                                    group-hover:translate-x-1
                                                "
                                            />

                                        </div>

                                    </div>

                                </div>

                            </Link>

                        );

                    })}

                </div>


                {/* Button */}

                <div className="mt-16 text-center">

                    <Link
                        to="/blogs"
                        className="
                            inline-flex
                            items-center
                            gap-3
                            rounded-2xl
                            bg-[#D9BB74]
                            px-8
                            py-3
                            text-sm
                            font-semibold
                            text-[#1B1B1B]
                            shadow-lg
                            transition-all
                            duration-300
                            hover:bg-[#0F766E]
                            hover:text-white
                        "
                    >
                        View All Articles

                        <ArrowRight
                            size={18}
                        />
                    </Link>

                </div>

            </div>

        </section>

    );

}